// Componente principal de la aplicación Amarsi Control Panel
// Configura los providers y el sistema de rutas centralizado

import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Providers y contexto
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { SidebarProvider } from './context/SidebarContext';

// Sistema de rutas centralizado
import AppRoutes from './routes';

// Sistema de notificaciones Toast personalizado
import { ToastProvider } from './hooks/useToast';

// Configuración de React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // No reintentar errores de autenticación
        if (error.message?.includes('Invalid') || error.message?.includes('Unauthorized')) {
          return false;
        }
        return failureCount < 2;
      },
      staleTime: 1000 * 60 * 5, // 5 minutos
      cacheTime: 1000 * 60 * 10, // 10 minutos
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false, // Las mutaciones no se reintentan automáticamente
    },
  },
});

/**
 * Componente App
 *
 * Estructura principal de la aplicación con:
 * - React Query para gestión de estado del servidor
 * - React Router para navegación
 * - Contexto de autenticación
 * - Sistema de rutas centralizado con layouts
 * - Sistema de notificaciones Toast personalizado
 */
const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <SidebarProvider>
        <ThemeProvider>
          <AuthProvider>
            <Router>
              <ToastProvider>
                <div>
                  {/* Sistema de rutas centralizado */}
                  <AppRoutes />
                </div>
              </ToastProvider>
            </Router>
          </AuthProvider>
        </ThemeProvider>
      </SidebarProvider>
    </QueryClientProvider>
  );
};

export default App;
